import { render, staticRenderFns } from "./welfare-item.vue?vue&type=template&id=53650d26&scoped=true&"
import script from "./welfare-item.vue?vue&type=script&lang=js&"
export * from "./welfare-item.vue?vue&type=script&lang=js&"
import style0 from "./welfare-item.vue?vue&type=style&index=0&id=53650d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53650d26",
  null
  
)

export default component.exports